<template>
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" fill-rule="evenodd" viewBox="0 0 84.7 37.6">
        <title>{{strings['PneuOffer.TTWetGrip']}}: {{labelText}}</title>
        <path d="M56.3 7.9a4 4 0 0 0-4-4l-.7.1a4 4 0 0 0-4-3.6A4 4 0 0 0 44 2.6a2.5 2.5 0 0 0-1.6-.7C41 2 40 3 39.9 4.1a4 4 0 0 0-5 3.8 4 4 0 0 0 4 4h13.3a4 4 0 0 0 4-4" fill="#fff" />
        <path d="M56.3 7.9a4 4 0 0 0-4-4l-.7.1a4 4 0 0 0-4-3.6A4 4 0 0 0 44 2.6a2.5 2.5 0 0 0-1.6-.7C41 2 40 3 39.9 4.1a4 4 0 0 0-5 3.8 4 4 0 0 0 4 4h13.3a4 4 0 0 0 4-4zM42.2 12 41 13.8M46 12l-1.2 1.7M50 12l-1.2 1.7M40 14.9 39 16.6M43.9 14.9l-1.2 1.7M47.8 14.9l-1.2 1.7M45.7 17.8l-1.2 1.6" stroke="#000" stroke-width=".8" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M10.3 37.3c-3.4.2-5.4.2-6.8-.6-1.1-.5-1.8-1.6-1.4-2.5.4-.9 1.7-1.2 2.9-.8 1.8.7 2 2 5.3 4" fill="#fff" />
        <path d="M10.3 37.3c-3.4.2-5.4.2-6.8-.6-1.1-.5-1.8-1.6-1.4-2.5.4-.9 1.7-1.2 2.9-.8 1.8.7 2 2 5.3 4z" stroke="#000" stroke-width=".8" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M30 37.3c3.4.2 5.3.2 6.8-.6 1-.5 1.7-1.6 1.3-2.5-.4-.9-1.7-1.2-2.8-.8-1.8.7-2 2-5.3 4" fill="#fff" />
        <path d="M30 37.3c3.4.2 5.3.2 6.8-.6 1-.5 1.7-1.6 1.3-2.5-.4-.9-1.7-1.2-2.8-.8-1.8.7-2 2-5.3 4z" stroke="#000" stroke-width=".8" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M35.1 30.9c1-.4 3.2-.7 4.1-1.3.7-.4.8-1.3.4-1.9-.5-.6-1.4-.7-2-.3-1.1.7-1.6 2.4-2.5 3.5" fill="#fff" />
        <path d="M35.1 30.9c1-.4 3.2-.7 4.1-1.3.7-.4.8-1.3.4-1.9-.5-.6-1.4-.7-2-.3-1.1.7-1.6 2.4-2.5 3.5z" stroke="#000" stroke-width=".8" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M5.1 30.9c-1-.4-3.2-.7-4-1.3-.7-.4-1-1.3-.5-1.9.5-.6 1.4-.7 2-.3 1.1.7 1.7 2.4 2.5 3.5" fill="#fff" />
        <path d="M5.1 30.9c-1-.4-3.2-.7-4-1.3-.7-.4-1-1.3-.5-1.9.5-.6 1.4-.7 2-.3 1.1.7 1.7 2.4 2.5 3.5z" stroke="#000" stroke-width=".8" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M16.1 37C11.6 37 8 30 8 21.3 8 13 11.6 6 16.1 6h9.5c4.5 0 8.1 7 8.1 15.5 0 8.6-3.6 15.5-8 15.5z" fill="#000" />
        <path d="M26.5 37.1c-4.5 0-8-7-8-15.6 0-8.7 3.3-15.7 7.9-15.7" stroke="#fff" stroke-width=".3" />
        <path d="M26.8 10.4c-2.5 0-4.5 4.8-4.5 10.7 0 6 2 10.7 4.5 10.7s4.5-4.8 4.5-10.7c0-6-2-10.7-4.5-10.7m-.4 20.9c-2.1 0-3.8-4.5-3.8-10.1S24.3 11 26.4 11c2.1 0 3.9 4.5 3.9 10 0 5.7-1.8 10.2-3.9 10.2" fill="#fff" />
        <path d="m23.6 14.5-.4.7-.5 2.2-.2 2.4V23l.5 3.5.6 1.7c1.4 0 2.5-3 2.5-6.5 0-3.6-1.1-7.2-2.5-7.2" fill="#fff" />
        <path d="M20.7 37.3c-4.6 0-8.3-7.1-8.3-15.8 0-8.7 3.7-15.9 8.3-15.9m-2.5 31.6c-4.6 0-8.3-7.1-8.3-15.8 0-8.6 3.8-15.9 8.4-15.9M12.5 19.7l-2.4-.1m2.3 2.9-2.5-.1m2.7 2.6L10 25m2.8 2.2-2.4-.1m3 2.4-2.5-.1m3 1.7h-2.3m3 1.5h-2.5m3.3 1.3H13m3.3 1-2.4.1m3.3 1h-2.4m-2-19.2-2.5-.1m3-2.2h-2.4m3-2h-2.5m3-1.4H12m3-1.2h-2.4m5.5 26.8h-2.3m-.1-27.8h-2.5m3.2-1h-2.4m3.1-.8h-2.4m3.5-.7h-2.5" stroke="#fff" stroke-width=".3" />
        <path d="M24.5 37.4c-4.4 0-7.9-7.1-7.9-15.8 0-8.7 3.6-16 8-16m-2.5 31.7c-4.4 0-7.9-7.1-7.9-15.8 0-8.6 3.6-15.9 8-15.9M16.6 19.8l-2.3-.1m2.3 2.9-2.4-.1m2.6 2.6-2.4-.1m2.6 2.2-2.2-.1m2.8 2.4-2.4-.1m3 1.7h-2.3m3 1.5h-2.4m3 1.3h-2.3m3.1 1L18 35m3.2.9h-2.3m-2-19.1-2.3-.1m2.8-2.2h-2.2m2.8-2h-2.4m2.9-1.4h-2.2m3-1.2h-2.5m5.3 26.7-2.2.1m0-27.9h-2.4m3-1h-2.3m3-.7H19m3.3-.7h-2.4" stroke="#fff" stroke-width=".3" />
        <g style="stroke:#000">
            <path d="M53.4 15h22.1l9.1 9.1-9 9.1H53.3z" stroke-width="1" :fill="labelColor" />
            <text stroke-width="0.5" font-family="Calibri-Bold, Calibri, Helvetica Neue, sans-serif" font-size="15" font-weight="bold" fill="#fff" transform="translate(53.5 15.1)"><tspan x="4" y="13">{{labelText}}</tspan></text>
        </g>
    </svg>
</template>

<script>
    import { mapState } from 'vuex';

    export default {
        props: {
            category: {
                type: String,
                required: true
            }
        },
        computed: {
            ...mapState([
                'strings'
            ]),
            labelColor() {
                switch (this.category.toUpperCase()) {
                    case "A":
                        return "#005b9c";
                    case "B":
                        return "#0076b0";
                    case "C":
                        return "#4e9cc9";
                    case "D":
                        return "#74b7d9";
                    case "E":
                        return "#acdcec";
                    default:
                        return "#ffffff";
                }
            },
            labelText() {
                return this.category.toUpperCase();
            }
        }
    };
</script>